<template>
    <div class="side-bar" ref="aside" :class="{ 'menu-collapsed': !isCollapse }">
        <h1 class="side-bar-title" :class="{ 'side-bar-title-close': isCollapse }">
            <slot name="logo"></slot>
            <slot name="logoDetail" v-if="!isCollapse"></slot>
        </h1>
        <el-scrollbar class="side-bar-scrollbar">
            <sidebar-menu :menus="searchMenus" :uniqueOpened="uniqueOpened" :openeds="openeds" :collapse="isCollapse"></sidebar-menu>
        </el-scrollbar>
        <div class="side-bar-btn-wrap">
            <el-input
                prefix-icon="iconfont iconsearch_Inquire"
                class="side-bar-search"
                size="mini"
                v-show="!isCollapse"
                v-model="searchMenuName"
                @keyup="handleEnter"
            ></el-input>
            <el-button
                class="side-bar-open-btn"
                type="text"
                :icon="isCollapse ? 'iconfont icon-unfold' : 'iconfont icon-retract'"
                @click="togglePay"
            ></el-button>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, computed, watch, ref } from 'vue';
import store from '@/store';
import SidebarMenu from './SidebarMenu';

const getResourceIds = v => {
    const tempArr = [];
    getId(v);

    function getId(v) {
        v.forEach(item => {
            if (item.resourceType && +item.resourceType === 1 && item.subResources) {
                getId(item.subResources);
            } else if (item.resourceType && +item.resourceType === 2) {
                tempArr.push(item);
            }
        });
    }
    return tempArr;
};

export default defineComponent({
    name: 'Sidebar',
    components: {
        SidebarMenu
    },
    props: {
        uniqueOpened: {
            type: Boolean,
            default() {
                return true;
            }
        },
        openeds: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    setup() {
        // data
        let originMenu = [];
        const searchMenus = ref([]);
        const searchMenuName = ref(null);
        const isCollapse = ref(false);

        // computed
        const authority = computed(() => {
            return store.getters.menus;
        });

        // mounted
        onMounted(() => {
            searchMenus.value = JSON.parse(JSON.stringify(authority.value));
            const { clientWidth } = document.body;
            const minWidth = 1366;
            if (clientWidth <= minWidth) {
                // 文档宽度小于1366时，默认收起菜单
                isCollapse.value = true;
            }
            // 原nexttick
            // eventBus sidebarIsCollapse
            // this.$eventBus.$emit('sidebarIsCollapse', isCollapse.value);
        });

        // watch
        watch(
            authority,
            (newVal, oldVal) => {
                // console.log('authority newVal:', newVal, 'authority oldVal:', oldVal);
                originMenu = JSON.parse(JSON.stringify(newVal));
                searchMenus.value = JSON.parse(JSON.stringify(originMenu));
            },
            { immediate: true }
        );

        // methods
        const togglePay = () => {
            isCollapse.value = !isCollapse.value;
            store.commit('updateIsCollapse', isCollapse.value);
        };
        const handleEnter = () => {
            if (searchMenuName.value) {
                let temp = getResourceIds(originMenu);
                temp = temp.filter(item => {
                    return item.resourceName.indexOf(searchMenuName.value) !== -1;
                });
                searchMenus.value = temp;
            } else {
                searchMenus.value = originMenu;
            }
            if (window._paq) {
                window._paq.push(['trackEvent', 'Menu', 'Enter', '菜单搜索']);
            }
        };

        return {
            searchMenus,
            searchMenuName,
            isCollapse,
            togglePay,
            handleEnter
        };
    }
});
</script>
